import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import InternalHeader from "../components/InternalHeader";
import BottomNav from "../components/BottomNav";
import { useAppState } from "../context/AppState";
import { authenticatedApi } from "../lib/api";

const statusLabels = {
  PENDING: ["Solicitud enviada", "Estamos buscando un conductor disponible."],
  CONFIRMED: ["Solicitud confirmada", "La central confirmó tu solicitud."],
  ASSIGNED: ["Conductor asignado", "Un conductor aceptó tu servicio."],
  PICKED_UP: ["Servicio en camino", "El paquete o pasajero salió del punto A."],
  DELIVERED: ["Servicio completado", "La entrega o viaje finalizó."],
  CANCELLED: ["Servicio cancelado", "Esta solicitud fue cancelada."],
};

export default function ServiceOrderDetailPage() {
  const { reference } = useParams();
  const { user } = useAppState();
  const [order, setOrder] = useState(null);
  const [loading, setLoading] = useState(Boolean(user));
  const [error, setError] = useState("");

  async function load() {
    if (!user?.auth_token) return;
    try {
      const response = await authenticatedApi("/service-hub/my-orders", user.auth_token);
      const found = response?.orders?.find((entry) => entry.reference === reference);
      if (!found) throw new Error("Servicio no encontrado.");
      setOrder(found);
      setError("");
    } catch (requestError) {
      setError(requestError.message);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    load();
    const timer = window.setInterval(load, 30000);
    return () => window.clearInterval(timer);
  }, [reference, user?.auth_token]);

  const status = statusLabels[order?.status] || [order?.status, ""];

  return (
    <main className="food-app">
      <InternalHeader title="Mis pedidos" backTo="/orders" />
      <div className="order-detail">
        {!user && <section className="empty-cart"><h2>Inicia sesión para ver el servicio</h2><Link to={`/account?next=/service-orders/${reference}`}>Ir a mi cuenta</Link></section>}
        {loading && <div className="food-message"><b>Cargando servicio…</b></div>}
        {error && <div className="food-message food-message--error"><b>{error}</b></div>}
        {order && (
          <>
            <header className="order-detail__heading">
              <div><small>{order.service_type === "TAXI" ? "TAXI" : "ENVÍO"} {order.reference}</small><h1>{status[0]}</h1><time>{order.created_at}</time></div>
              <strong>S/ {Number(order.total || 0).toFixed(2)}</strong>
            </header>
            <section className={`service-order-status is-${String(order.status).toLowerCase()}`}><span>{order.status === "DELIVERED" ? "✓" : "⌁"}</span><div><b>{status[0]}</b><small>{status[1]}</small></div></section>
            <section className="driver-route-card">
              <div><small>PUNTO A</small><b>{order.pickup_address}</b><span>{order.pickup_reference}</span></div><i />
              <div><small>PUNTO B</small><b>{order.dropoff_address}</b><span>{order.dropoff_reference}</span></div>
              <a href={`https://www.google.com/maps/dir/?api=1&origin=${order.pickup_latitude},${order.pickup_longitude}&destination=${order.dropoff_latitude},${order.dropoff_longitude}`} target="_blank" rel="noreferrer">Ver ruta en mapa</a>
            </section>
            <section className="order-detail__card">
              <h2>Detalle</h2>
              <p>{order.package_description}</p>
              <p><b>Distancia:</b> {order.distance_km} km · {order.duration_min} min</p>
              {order.customer_notes && <p><b>Indicaciones:</b> {order.customer_notes}</p>}
            </section>
          </>
        )}
      </div>
      <BottomNav />
    </main>
  );
}
